import { apiRequest } from '@/utils/apiRequest';
import { apiUrl } from '@/utils/apiUrl';

export class NotificationRepository {
	constructor() {
		const host = window.location.hostname;
		if (host === 'localhost' || host.startsWith('192.168')) {
			this.urlBase = process.env.VUE_APP_API_BASE_URL;
		} else {
			this.urlBase = window.location.origin;
		}
	}

	async requestTicket(data) {
		try {
			const response = await apiRequest({ url: apiUrl('/world/notification/new'), method: 'POST', body: data, throwOnNonOk: false });
			if (!response.ok) return response.status;
			return response.data;
		} catch (e) {
			console.log('Ups, algo ha ido mal solicitando la cuenta.');
		}
	}

	async getRecentNotifications() {
		try {
			const { data, status } = await apiRequest({
				url: apiUrl('/world/api/notifications/recent'),
				method: 'GET',
				body: null,
				expect: 'json',
				throwOnNonOk: false,
			});

			if (status !== 200) {
				const err = new Error(data?.message || `HTTP ${status}`);
				err.status = status;
				err.data = data;
				throw err;
			}

			return data;
		} catch (e) {
			console.log('Error fetching recent notifications:', e);
			return [];
		}
	}

	async acknowledgeNotification(notificationId, notificationData) {
		try {
			const { data } = await apiRequest({
				url: apiUrl(`/world/api/notifications/${notificationId}/ack`),
				method: 'POST',
				body: notificationData ?? {},
				expect: 'json',
				throwOnNonOk: true,
			});

			return data;
		} catch (e) {
			console.log('Error acknowledging notification:', e);
			throw e;
		}
	}

	async getNotifications(date = null) {
		try {
			let url = apiUrl('/world/api/notifications');

			if (date) {
				url += `?date=${encodeURIComponent(date)}`;
			}

			const { data, status } = await apiRequest({
				url: url,
				method: 'GET',
				body: null,
				expect: 'json',
				throwOnNonOk: false,
			});

			if (status !== 200) {
				const err = new Error(data?.message || `HTTP ${status}`);
				err.status = status;
				err.data = data;
				throw err;
			}

			return data;
		} catch (e) {
			console.log('Error fetching notifications:', e);
			return [];
		}
	}

	async getTicketRequestNotifications() {
		try {
			const { data, status } = await apiRequest({
				url: apiUrl('/world/api/notifications/ticket-request'),
				method: 'GET',
				body: null,
				expect: 'json',
				throwOnNonOk: false,
			});

			if (status !== 200) {
				const err = new Error(data?.message || `HTTP ${status}`);
				err.status = status;
				err.data = data;
				throw err;
			}

			return data;
		} catch (e) {
			console.log('Error fetching ticket request notifications:', e);
			return [];
		}
	}

	async getUpsellingNotificationsData(dateFrom, dateTo) {
		try {
			const { data, status } = await apiRequest({
				url: apiUrl('/world/api/notification/report/upselling'),
				method: 'POST',
				body: {
					from: dateFrom,
					to: dateTo,
				},
				expect: 'json',
				throwOnNonOk: false,
			});
			if (![200, 201].includes(status)) {
				const err = new Error(data?.message || `HTTP ${status}`);
				err.status = status;
				err.data = data;
				throw err;
			}
			return data;
		} catch (e) {
			console.log('Error fetching upselling notifications:', e);
			return [];
		}
	}
}

export const notificationRepository = new NotificationRepository();
